var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('d-modal',{attrs:{"size":"lg"},on:{"close":_vm.handleClose}},[_c('d-modal-header',[_c('d-modal-title',[_vm._v(" Add new crew ")])],1),_c('d-modal-body',[_c('crew-form',{attrs:{"isPopup":true,"customerID":_vm.customerID}})],1)],1)}
var staticRenderFns = []

export { render, staticRenderFns }